import { BLOCKS, Node } from '@contentful/rich-text-types';
import { fontGroups } from '@zoopla-eng/zds-components/themes';
import { CONTENTFUL_RICH_TEXT_OPTIONS } from '@zoopla/cms/contentful-render-options';
import { textStyle } from './banner.styles.css';

export const BANNER_RENDER_OPTIONS = {
    ...CONTENTFUL_RICH_TEXT_OPTIONS,
    renderNode: {
        ...CONTENTFUL_RICH_TEXT_OPTIONS.renderNode,
        [BLOCKS.PARAGRAPH]: (_node: Node, children: React.ReactNode) => {
            const isEmptyChildren = children?.toString().trim() === '';
            if (isEmptyChildren) return null;

            return (
                <p className={`${textStyle} ${fontGroups.whisk}`}>{children}</p>
            );
        }
    }
};
